import { Link } from "react-router-dom";
import "./live.css";

export default function LiveList({ lives, onJoinLive, loading }) {
  if (loading) {
    return (
      <div className="live_list_loading">
        <div className="live_skeleton"></div>
        <div className="live_skeleton"></div>
      </div>
    );
  }

  if (!lives || lives.length === 0) {
    return (
      <div className="live_list_empty">
        <div className="empty_icon">
          <i className="fa fa-video-camera"></i>
        </div>
        <h3>Nenhuma live no momento</h3>
        <p>Quando seus amigos iniciarem uma live, ela aparecerá aqui.</p>
      </div>
    );
  }

  return (
    <div className="live_list">
      <h2 className="live_list_title">Lives Ativas</h2>
      <div className="live_list_grid">
        {lives.map((live) => (
          <div
            key={live._id}
            className="live_card"
            onClick={() => onJoinLive(live)}
          >
            <div className="live_card_thumbnail">
              {live.thumbnail ? (
                <img src={live.thumbnail} alt="" />
              ) : (
                <div className="live_card_placeholder">
                  <img src={live.host?.picture} alt="" className="host_img_large" />
                </div>
              )}
              <div className="live_badge">
                <span className="live_dot"></span>
                AO VIVO
              </div>
              <div className="live_viewers_badge">
                <i className="fa fa-eye"></i>
                {live.currentViewers || 0}
              </div>
            </div>
            <div className="live_card_info">
              <Link
                to={`/profile/${live.host?.username}`}
                className="live_host"
                onClick={(e) => e.stopPropagation()}
              >
                <img src={live.host?.picture} alt="" />
                <span>
                  {live.host?.first_name} {live.host?.last_name}
                </span>
              </Link>
              {live.title && <p className="live_title">{live.title}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
